import React from "react";
import "../styles/components/BlogPost.css";
import PropTypes from "prop-types";
import DOMPurify from "isomorphic-dompurify";

// blog posts include id, title, date posted, and body

const BlogPost = (props) => {
  const bodyText = { __html: DOMPurify.sanitize(props.body) };
  return (
    <div key={props.id}>
      <h3>{props.title}</h3>
      <small>{props.date}</small>
      <div id="blog-title-separator" />
      <p dangerouslySetInnerHTML={bodyText}></p>
    </div>
  );
};

BlogPost.propTypes = {
  id: PropTypes.number.isRequired,
  title: PropTypes.string.isRequired,
  date: PropTypes.string.isRequired,
  body: PropTypes.string.isRequired,
};

export default BlogPost;
